<template lang="pug">
  ProductForm(:data="data")
  //- pre {{ data }}
</template>

<script>
import ProductForm from './ProductForm'

export default {
  name: 'ProductEdit',
  components: {
    ProductForm
  },
  data () {
    return {
      data: {
        id: undefined,
        menu_order: 0,
        categories: [],
        cards: [
          {
            item_no: '',
            size: '',
            caliber: '',
            capacity: ''
          }
        ]
      }
    }
  },
  methods: {
    async getDetail() {
      if (!this.$route.params.id) return;

      let result = await this.$http.get(`product/${this.$route.params.id}`);
      if (result.content.indexOf('[{') !== -1) {
        result.cards = JSON.parse(result.content);
      } else {
        result.cards = [
          {
            item_no: '',
            size: '',
            caliber: '',
            capacity: ''
          }
        ]
      }
      
      this.data = result;
    },
  },
  created() {
    this.getDetail();
  }
}
</script>

<style lang="less" scoped></style>